/**
 * Bytes per Megabyte.
 *
 * @type {number}
 */
export const BYTES_PER_MEGABYTE = 1048576;
/**
 * Max file size to upload in MB.
 *
 * @type {number}
 */
export const MAX_FILE_SIZE_TO_UPLOAD = 10;

export const FILE_UPLOAD_PLACEHOLDER = 'Select a file...';

export const BACK_TO_TOP_BUTTON_LABEL = 'BACK TO TOP';

export const RESET_ALL = 'Reset All';

export const GO_TO_PAGE = 'GO TO PAGE';

export const SHOW_MORE = 'SHOW MORE';

export const SHOW_LESS = 'SHOW LESS';

export const SHOW_ALL = 'SHOW ALL';

export const COMPARE = 'COMPARE';

export const NONE = 'None';

export const AUDIT_TRAIL_KEYS_TO_CONVERT = ['canCreateBdcDocuments', 'isActive'];
